import React from "react";

import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import { Autocomplete, Box, Button, IconButton, Paper, Stack, TextField } from "@mui/material";
import { useCanCreateDeal, usePrompt } from "hooks";
import { useTaskDealsSelect } from "store";
import { DealBase } from "store/types";

import { CreateDealContent } from "../../../Prompts/CreateDealContent";
import { useEmailsContext } from "../context/Email-context";

interface Props {}
export const SelectDeal: React.FC<Props> = () => {
  const canCreateDeal = useCanCreateDeal();
  const { handleMultipleMove, onCancelSelectDeal, handleMultipleDelete, selectedDeal, setSelectedDeal } =
    useEmailsContext();
  const openPrompt = usePrompt();
  const deals = useTaskDealsSelect();

  const onCreateNewDeal = async () => {
    const data = await openPrompt({
      Component: CreateDealContent
    });
    if (data) {
      setSelectedDeal({ id: data?.dealId, title: data?.dealTitle } as DealBase);
    }
  };

  return (
    <Stack gap={"12px"}>
      <Autocomplete
        disableClearable
        options={deals}
        value={selectedDeal || undefined}
        getOptionLabel={(option) => option.title}
        renderOption={(props, option) => (
          <li {...props} key={option.id}>
            {option.title}
          </li>
        )}
        PaperComponent={({ children }) => {
          return (
            <Paper
              sx={{
                position: "absolute",
                backgroundColor: "white",
                zIndex: "10",
                width: "100%",
                borderRadius: "10px",
                "& .MuiAutocomplete-option:hover": {
                  backgroundColor: "#edf1f9"
                }
              }}
            >
              <>
                {children}
                {canCreateDeal && (
                  <Button
                    onMouseDown={async () => {
                      await onCreateNewDeal();
                    }}
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      height: "50px",
                      backgroundColor: "#fff",
                      boxShadow: "-2px 2px 15px -2px rgba(0, 0, 0, 0.25)",
                      borderRadius: "0 0 10px 10px"
                    }}
                    fullWidth
                  >
                    Add Deal
                  </Button>
                )}
              </>
            </Paper>
          );
        }}
        onChange={(_, option) => option && setSelectedDeal(option)}
        renderInput={(params) => <TextField {...params} label="Deal" />}
      />

      <Stack direction="row" gap={"20px"} justifyContent="flex-end">
        <Box sx={{ flexGrow: 1 }}>
          <IconButton onClick={handleMultipleDelete}>
            <DeleteOutlineOutlinedIcon sx={{ fontSize: 20 }} color="primary" />
          </IconButton>
        </Box>
        <Button variant="text" onClick={onCancelSelectDeal}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          startIcon={<ForwardToInboxIcon />}
          onClick={handleMultipleMove}
          disabled={!selectedDeal}
        >
          Associate
        </Button>
      </Stack>
      {/* <EmailCreateDealModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        setSuggestion={async (suggestion) => {
          await getDealsAction();
          setDeal(suggestion.deal);
        }}
      /> */}
    </Stack>
  );
};
